<script setup>
import { computed, onMounted, watch, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import MultiSelectComponent from "@/components/MultiSelectComponent.vue";

const store = useStore();
const route = useRoute();

const course = computed(() => store.getters["course/getCourse"]);
const message = computed(() => store.getters["course/getMessage"]);
const errors = computed(() => store.getters["course/getErrors"]);
const allCourses = computed(() => store.getters["courses/getCourseNames"]);
const loading = computed(() => store.getters["course/isLoadingAssociates"]);

const selectedCourses = ref(
  course.value?.associates.map((course) => ({
    id: course.associated_id,
    name: course.associated_name,
  })) || []
);

watch(message, (newValue) => {
  if (newValue) {
    store.dispatch("toastNotification/displayToast", {
      message: newValue,
      type: "success",
    });
  }
});

watch(errors, (newValue) => {
  if (newValue) {
    store.dispatch("toastNotification/displayToast", {
      message: newValue,
      type: "error",
    });
  }
});

const updateAssociates = async () => {
  const ids = selectedCourses.value.map((course) => course.id);
  await store.dispatch("course/updateAssociates", {
    courseId: route.params.id,
    associates: ids,
  });
};

const isUpdateDisabled = computed(() => {
  if (
    selectedCourses.value.length === 0 &&
    course.value?.associates.length === 0
  ) {
    return true;
  }
  const sIds = selectedCourses.value.map((s) => s.id);
  const cIds = course.value?.associates.map((s) => s.associated_id) || [];
  return (
    sIds.length === cIds.length && cIds.every((id, index) => id === sIds[index])
  );
});

onMounted(async () => {
  await store.dispatch("courses/fetchCourseNames");
});
</script>

<template>
  <div v-if="course.is_primary" class="col-12">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Associates</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-10">
            <MultiSelectComponent
              v-model="selectedCourses"
              :options="allCourses"
              label="name"
              track-by="id"
              placeholder="Select Course"
            />
          </div>
          <div class="col-2">
            <button
              @click="updateAssociates"
              class="btn btn-primary"
              style="width: 100%"
              :disabled="loading || isUpdateDisabled"
            >
              <font-awesome-icon
                v-show="loading"
                :icon="['fas', 'spinner']"
                spin
              />
              <span v-show="!loading">UPDATE</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
